export default __webpack_public_path__ + "static/media/Link_Default_Icon.fa4657f6.svg";